<template>
    <div>
        <section class="sub-head d-none d-md-block" :style="{ height: subHeadHeight, }">
            <div class="sub-head-bgcontainer">
                <v-img 
                    :src="require('@/assets/bg_subheader_0' + $route.meta.cate + '.jpg')"
                    height="100%"
                    gradient="to top, rgba(0,0,0,.6), rgba(0,0,0,.84)"
                />
            </div>
            <div class="res_wrap px-5">
                <div>
                    <h2 class="mt-16">
                        {{$route.meta.breadcrumb[1].text}}
                        <!-- <small>Nice script here, England scraps pre-departure</small> -->
                        <small>{{subtitles[$route.meta.cate - 1].txt}}</small>
                    </h2>

                    <!-- <v-breadcrumbs  :items="$route.meta.breadcrumb">
                    <template v-slot:item="{ item }">
                        <v-breadcrumbs-item :href="item.href" :to="item.to">
                            <span v-if="item.text != 'Home'">{{ item.text.toUpperCase() }}</span>
                            <span v-else><v-icon small>mdi-home</v-icon></span>
                        </v-breadcrumbs-item>
                    </template>
                    </v-breadcrumbs> -->
                </div>
            </div>
        </section>

        <section class="sub-head mob d-md-none" :style="{ height: subHeadHeightM, }">
            <div class="sub-head-bgcontainer">
                <v-img 
                    :src="require('@/assets/bg_subheader_0' + $route.meta.cate + '.jpg')"
                    height="100%"
                    gradient="to top, rgba(0,0,0,.6), rgba(0,0,0,.84)"
                />
            </div>
            <div class="res_wrap px-5">
                <div>
                    <h2 class="mt-10">
                        {{$route.meta.breadcrumb[1].text}}
                        <small>{{subtitles[$route.meta.cate - 1].txt}}</small>
                    </h2>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
  export default {
    name: 'sub-header',
    data () {
      return {
        title: void 0,
        subHeadHeight: '26rem',
        subHeadHeightM: '14rem',
        subtitles: [
            { txt: '고객에게 가치를 제공하고 신뢰받는 최고의 솔루션과 지식 서비스 기업 입니다.', },
            { txt: '차별화된 기술력과 노하우를 기반으로 기업에 필요한 혁신적인 솔루션과 맞춤형 서비스를 제공하고 있습니다.', },
            { txt: '업무 자동화(Auto-Station, RPA, Chatbot), EAI, Framework 제품을 제공하고 있습니다.', },
            { txt: '제품 및 서비스에 대한 상담을 원하시면 문의 부탁 드립니다.', },
        ],
      }
    },
    methods: {
      showTitle () {
        this.title = 'The sub header'
      }
    }
  }
</script>